import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryListTableComponent } from './history-list-table.component';
import { SharedPipesModule } from '@fantaz/shared/pipes';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ResponsiveTableModule } from '@fantaz/shared/directives/responsive-table';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EmptyListModule } from '@fantaz/shared/ui/empty-list';
import { TournamentsUiFilterModule } from '@fantaz/tournaments-v2/ui/filters';
import { SharedUiLoadingComponentModule } from '@fantaz/shared/ui/loading-component';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { SharedUiTableComponentModule } from '@fantaz/shared/ui/table-component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    EmptyListModule,
    ResponsiveTableModule,
    MatPaginatorModule,
    SharedPipesModule,
    CurrencyModule,
    MatButtonModule,
    MatTooltipModule,
    SharedUiLoadingComponentModule,
    TournamentsUiFilterModule,
    SharedPipesDateModule,
    SharedUiTableComponentModule,
  ],
  declarations: [HistoryListTableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [HistoryListTableComponent],
})
export class GameHistoryUiHistoryListTableModule {}
